<template>
    <v-card class="pa-2 d-flex justify-space-between myBlue2 white--text">
        <v-card class="font-weight-medium my-1 transparent" elevation="0">
            <div class="white--text">{{ item.title }}</div>
            <div v-if="discount" class="d-flex">
                <div class="white--text">
                    {{ parseRupiah(item.price - (item.price * item.menu_discount) / 100) }},-
                </div>
            </div>
            <div v-else>
                <div class="white--text">{{ parseRupiah(item.price) }},-</div>
            </div>
        </v-card>
        <v-card-actions class="d-flex justify-start mr-3">
            <div v-if="quantity" class="d-flex justify-center text-center">
                <v-btn elevation="0" fab x-small icon @click="minusMenu()">
                    <v-icon color="white">mdi-minus</v-icon>
                </v-btn>
                <div class="d-flex justify-center align-center mx-1">
                    {{ quantity }}
                </div>
                <v-btn elevation="0" fab x-small icon @click="plusMenu()">
                    <v-icon color="white">mdi-plus</v-icon>
                </v-btn>
            </div>
            <v-btn v-else class="myYellow1" @click="addMenu()">Add</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    props: ["item", "quantity", "discount"],
    methods: {
        parseRupiah(price) {
            if (price == null) {
                return "";
            } else {
                return "Rp " + price.toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1.");
            }
        },
        addMenu() {
            this.$emit("addMenu");
        },
        minusMenu() {
            this.$emit("minusMenu");
        },
        plusMenu() {
            this.$emit("plusMenu");
        },
    },
};
</script>
